import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import Alert from "../elements/blocks/alert";
export default function Footer() {
    return (_jsx(Fragment, { children: _jsx(Alert, {}) }));
}
